import { wrap } from 'comlink';

export class Processor {
    private processes: any[] = [];
    private wrappedWorker: ReturnType<typeof wrap<any>> | null = null;
    private url: string | null = null;

    setWorker(worker: Worker) {
        this.wrappedWorker = wrap(worker);
    }

    clearWorker() {
        this.wrappedWorker = null;
    }

    setUrl(url: string) {
        this.url = url;
        console.log('processor setUrl', url);
        this.get().then(() => {
            console.log('processor init success');
        });
    }

    setError(error: any) {
        const publicUrl = process.env.PUBLIC_URL;
        console.log('processor setError', { error, publicUrl });
        const url = (error as Error)?.message?.match(`${publicUrl}.*\.js`)?.[0] || '';
        this.setUrl(url);
    }

    get<T>(): Promise<T> {
        return new Promise((resolve) => {
            if (this.wrappedWorker) {
                resolve(this.wrappedWorker as T);
                return;
            }
            if (!this.processes.length && this.url) {
                fetch(this.url)
                    .then((response) => response.text())
                    .then((text) => {
                        const blob = new Blob([text], { type: 'application/javascript' });
                        const worker = new Worker(URL.createObjectURL(blob));
                        this.setWorker(worker);
                        for (const process of this.processes) {
                            process(this.wrappedWorker! as T);
                        }
                        this.processes.length = 0;
                    });
            }
            this.processes.push(resolve);
        });
    }
}
